import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Pick-lists for the slab / remnant forms, managed in Settings → Slab Materials & Thicknesses.
export const DEFAULT_SLAB_OPTIONS = {
  materials: ["Granite", "Marble", "Quartz", "Quartzite", "Porcelain", "Soapstone", "Onyx"],
  thicknesses: ["1cm", "2cm", "3cm"],
};

let cached = null;

export const loadSlabOptions = async () => {
  if (cached) return cached;
  try {
    const { data } = await api.get("/settings/slab-options");
    cached = { ...DEFAULT_SLAB_OPTIONS, ...data };
  } catch {
    cached = DEFAULT_SLAB_OPTIONS;
  }
  return cached;
};

export const resetSlabOptions = () => {
  cached = null;
};

// A value already saved on the record but since removed from the list stays pickable.
export const withCurrent = (list, current) =>
  current && !list.includes(current) ? [current, ...list] : list;

export const useSlabOptions = () => {
  const [opts, setOpts] = useState(cached || DEFAULT_SLAB_OPTIONS);
  useEffect(() => {
    loadSlabOptions().then(setOpts);
  }, []);
  return opts;
};
